import { useState, useEffect } from "react";
import { Button, Card, Spin, Result } from "antd";
import { Link } from "react-router-dom";
import * as SHARED from "../../utils/shared";
import { me } from "../../api/participante";
import { CredencialButton } from "../../components/commons";

function EstadoInscripcion() {
  const [participante, setParticipante] = useState({
    _id: "",
    apellido: "",
    nombre: "",
    idtipoparticipante: "",
    personalmedico: null,
    idestado: "",
    directMessage: "",
    nrodocumento: "",
    isUploadedConstancy: true
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getEstadoInscripcion();
  }, []);

  const getEstadoInscripcion = async () => {
    try {
      setIsLoading(true);
      const response = await me();
      setParticipante(response.payload);
      setIsLoading(false);
    } catch (error) {
      setError(error);
      setIsError(true);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  const getParticipantState = (idestado) => {
    if (idestado === SHARED.ID_ESTADO_NO_INSCRITO) return SHARED.ESTADO_NO_INSCRITO.toUpperCase();
    if (idestado === SHARED.ID_ESTADO_PENDIENTE) return SHARED.ESTADO_PENDIENTE.toUpperCase();
    if (idestado === SHARED.ID_ESTADO_VALIDADO) return SHARED.ESTADO_VALIDADO.toUpperCase();
    if (idestado === SHARED.ID_ESTADO_OBSERVADO) return SHARED.ESTADO_OBSERVADO.toUpperCase();
    if (idestado === SHARED.ID_ESTADO_SORTEADO) return SHARED.ESTADO_SORTEADO.toUpperCase();
  };

  const colorEstado = (idestado) => {
    if (idestado === SHARED.ID_ESTADO_NO_INSCRITO) return "border-gray-200 bg-gray-100";
    if (idestado === SHARED.ID_ESTADO_PENDIENTE) return "border-blue-400 bg-blue-300";
    if (idestado === SHARED.ID_ESTADO_VALIDADO) return "border-green-400 bg-green-300";
    if (idestado === SHARED.ID_ESTADO_OBSERVADO) return "border-red-200 bg-red-300";
    if (idestado === SHARED.ID_ESTADO_SORTEADO) return "border-indigo-300 bg-indigo-400";
  };

  return (
    <div className="flex flex-col max-w-xs mx-auto text-center mt-4">
      <p className="text-base font-bold">INSCRIPCIÓN AL ROL DE </p>
      <span className="text-base font-bold text-blue-500 uppercase">
        {participante.tipoparticipante} {participante.personalmedico && "(PERSONAL MÉDICO)"}
      </span>
      <p className="text-base font-bold">EN MODALIDAD</p>
      <span className="text-base font-bold text-blue-500 uppercase">
        {participante.tipoparticipacion}
      </span>

      <span className="mt-4 text-gray-400">Nombres:</span>
      <p className="text-lg font-bold">{participante.nombre}</p>

      <span className="mt-4 text-gray-400">Apellidos:</span>
      <p className="text-lg font-bold">{participante.apellido}</p>

      <div className="flex flex-col">
        <span className="text-md text-gray-400 mt-4">
          Estado de su participación o documentación:
        </span>
        <span className="text-lg text-black font-bold">
          {getParticipantState(participante.idestado)}
        </span>
      </div>

      <Card className={"mt-8 px-2  text-sm rounded-lg " + colorEstado(participante.idestado)}>
        <div className="font-medium flex flex-col">
          <span>ADMISIÓN:</span>
          {participante.idestado === SHARED.ID_ESTADO_OBSERVADO ? (
            <span className="mt-2">{participante.directMessage}</span>
          ) : (
            <span className="mt-2">{participante.estadoMessage}</span>
          )}
        </div>
      </Card>

      {participante.idestado !== SHARED.ID_ESTADO_SORTEADO &&
        participante.idestado !== SHARED.ID_ESTADO_VALIDADO && (
          <Link
            to={{ pathname: SHARED.PATH_INSCRIPCION + SHARED.PATH_FORMULARIO }}
            style={{ width: "100%" }}
          >
            <Button type="primary" className="mt-4" style={{ width: "100%" }}>
              Editar formulario de inscripción
            </Button>
          </Link>
        )}

      {participante.idestado === SHARED.ID_ESTADO_SORTEADO && (
        <div className="flex flex-col justify-center mt-4">
          <CredencialButton user={participante} />
        </div>
      )}
    </div>
  );
}
export default EstadoInscripcion;
